// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {box-sizing:border-box}

@media (max-width: 768px){
  #bible{
    width: 100%;
  }
  #griddle{
    grid-template-columns: 1fr; /* to fix */
  }
}

#bible{
  margin-bottom: 20px;
}

/* Style the button that is used to open and close the collapsible content */
.collapsible {
  background-color: #5967c1;
  color: #ffffff;
  cursor: pointer;
  padding: 18px;
  width: 40%;
  border: none;
  text-align: center;
  outline: none;
  font-size: 15px;
}

/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
.collapsible:hover {
  background-color: #ccc;
  color: black;
}

/* Style the collapsible content. Note: hidden by default */
.dropContent {
  padding: 10px 18px;
  background-color: #f1f1f1;
  font-size: 22px;
  text-align: left;
}

#griddle {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
#griddle .collapsible{
  font-size: 25px;
  width: 100%;
}

.content {
    overflow: hidden;
    border: 1px solid rgb(128, 123, 123);
    padding: 0.5rem;
    border-radius: 5px;
}
.content-parent {
    overflow: hidden;
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.5s ease;
}
.content-parent.open {
    grid-template-rows: 1fr;
}
.content-parent:not(.open) .content {
    padding: 0;
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Beliefs.css"],"names":[],"mappings":"AAAA,GAAG,qBAAqB;;AAExB;EACE;IACE,WAAW;EACb;EACA;IACE,0BAA0B,EAAE,WAAW;EACzC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA,0IAA0I;AAC1I;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,wCAAwC;AAC5C;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,YAAY;AAChB","sourcesContent":["* {box-sizing:border-box}\n\n@media (max-width: 768px){\n  #bible{\n    width: 100%;\n  }\n  #griddle{\n    grid-template-columns: 1fr; /* to fix */\n  }\n}\n\n#bible{\n  margin-bottom: 20px;\n}\n\n/* Style the button that is used to open and close the collapsible content */\n.collapsible {\n  background-color: #5967c1;\n  color: #ffffff;\n  cursor: pointer;\n  padding: 18px;\n  width: 40%;\n  border: none;\n  text-align: center;\n  outline: none;\n  font-size: 15px;\n}\n\n/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */\n.collapsible:hover {\n  background-color: #ccc;\n  color: black;\n}\n\n/* Style the collapsible content. Note: hidden by default */\n.dropContent {\n  padding: 10px 18px;\n  background-color: #f1f1f1;\n  font-size: 22px;\n  text-align: left;\n}\n\n#griddle {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n#griddle .collapsible{\n  font-size: 25px;\n  width: 100%;\n}\n\n.content {\n    overflow: hidden;\n    border: 1px solid rgb(128, 123, 123);\n    padding: 0.5rem;\n    border-radius: 5px;\n}\n.content-parent {\n    overflow: hidden;\n    display: grid;\n    grid-template-rows: 0fr;\n    transition: grid-template-rows 0.5s ease;\n}\n.content-parent.open {\n    grid-template-rows: 1fr;\n}\n.content-parent:not(.open) .content {\n    padding: 0;\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
